import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=61eefdbf&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61eefdbf')) {
      api.createRecord('61eefdbf', component.options)
    } else {
      api.reload('61eefdbf', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=61eefdbf&", function () {
      api.rerender('61eefdbf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-24UlAZUunV0KD/JS/comp/ImgFallback.vue"
export default component.exports